"use strict";

exports.__esModule = true;
exports.VARIANT = exports.SIZE_TO_ROWS = exports.SIZE = void 0;
var SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  jumbo: 'jumbo'
};
exports.SIZE = SIZE;
var SIZE_TO_ROWS = {
  small: 2,
  medium: 6,
  large: 8,
  jumbo: 12
};
exports.SIZE_TO_ROWS = SIZE_TO_ROWS;
var VARIANT = {
  danger: 'danger',
  success: 'success',
  warning: 'warning'
};
exports.VARIANT = VARIANT;